var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.rendered)?_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('input',{attrs:{"type":"file"},on:{"change":_vm.handleFileUpload}})])])]):_c('div',[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-overlay"},[_c('span',{staticClass:"fas fa-spinner fa-3x fa-spin"})])
}]

export { render, staticRenderFns }